import React from "react"
import { IntroContainer, ProdLogoImg, Description, CtaLinks } from './intro.css';
import { graphql, Link } from 'gatsby';

import DownloadIcon from 'assets/icons/download.svg';
import NextIcon from 'assets/icons/chevron-right.svg';

const Intro = ({ title, author, description, assetsURL, firstLessonPath, prodLogos }) => (
    <IntroContainer className='container'>

        <h1>{ title }</h1>
        {author && <h2>{author}</h2>}
        <Description>{ description }</Description>

        <ProdLogoImg className='products-logo'>
            {prodLogos.map((logo) =>
                <img src={logo.url} alt={logo.alt} />
            )}
        </ProdLogoImg>

        <CtaLinks>
            <div>
                <a className="btn__cta btn--ghost btn__icon"
                   href={assetsURL}
                   download data-wat-link="true"
                   data-wat-val="Get the assets"
                   data-wat-loc={title + " Intro"}>
                        Get the assets
                        <span><DownloadIcon/></span>
                </a>
            </div>
            <div>
                <Link className="btn__cta btn--black btn__icon btn__icon--chevron"
                      to={firstLessonPath}
                      data-wat-link="true"
                      data-wat-val="Take the course"
                      data-wat-loc={title + " Intro"}>
                        Take the course
                        <span><NextIcon/></span>
                </Link>
            </div>
        </CtaLinks>
    </IntroContainer>
);

export default Intro


